<template>
  <div class="widget-section">
    <WidgetButton v-for="widget in widgetList" :key="widget.type" :widget="widget" :parent-id="parentId" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FunnelMixin from '@/components/Mixin'
import WidgetButton from '@/components/sidenav/landing/panel/widget/WidgetButton'

const PRODUCT_PAGE_TYPE = 'product'
const FUNNELS_PAGE_TYPE = 'funnels'

const SALE_OFFER_CATEGORY = 'saleOffer'

export default {
  name: 'PanelSideNavContentTabAddWidget',
  mixins: [FunnelMixin],
  i18nOptions: { keyPrefix: 'components.sidenav.landing.panel.add-widget' },
  components: { WidgetButton },
  computed: {
    ...mapGetters('landing', ['pageType', 'pageCategory']),
    productSaleOfferWidgets() {
      const saleOfferWidgets = [
        {
          text: this.$t('dynamic-text'),
          icon: 'fal fa-brackets-curly',
          type: 'DynamicText',
        },
      ]
      return this.pageType === PRODUCT_PAGE_TYPE && this.pageCategory === SALE_OFFER_CATEGORY ? saleOfferWidgets : []
    },
    funnelsPageWidgets() {
      const funnelsWidgets = [
        {
          text: this.$t('capture-form'),
          icon: 'fal fa-clipboard-list',
          type: 'CaptureForm',
        },
      ]
      return this.pageType === FUNNELS_PAGE_TYPE ? funnelsWidgets : []
    },
    widgetList() {
      return [
        ...this.productSaleOfferWidgets,
        ...this.funnelsPageWidgets,
        {
          text: this.$t('image'),
          icon: 'fal fa-image',
          type: 'Image',
        },
        {
          text: this.$t('video'),
          icon: 'fal fa-video',
          type: 'Video',
        },
        {
          text: this.$t('static-text'),
          icon: 'fal fa-align-left',
          type: 'Text',
        },
        {
          text: this.$t('button'),
          icon: 'fas fa-rectangle-wide',
          type: 'Button',
        },
        {
          text: this.$t('facebook-comments'),
          icon: 'fab fa-facebook-f',
          type: 'FacebookComments',
        },
        {
          text: this.$t('iframe'),
          icon: 'fal fa-file-code',
          type: 'Iframe',
        },
        {
          text: this.$t('form'),
          icon: 'fal fa-clipboard-list',
          type: 'Form',
          conditional: !this.isFromFunnel,
        },
        {
          text: this.$t('upsell'),
          icon: 'fal fa-funnel-dollar',
          type: 'Upsell',
        },
      ]
    },
  },
  props: {
    parentId: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.widget-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
}
</style>
